<template>
  <div>
    <page-header title="تنظیمات سئو" subtitle="عنوان، توضیحات و کلمات کلیدی هر صفحه برای موتورهای جستجو." english-toggle></page-header>

    <v-card class="settings-card" v-for="page in pages" :key="page.key">
      <v-card-title><v-icon left>{{ page.icon }}</v-icon>{{ page.title }}</v-card-title>
      <v-card-text>
        <template v-for="field in seoFields">
          <translated-field v-if="seoData[settingName(page.key, field.key)]"
                            :key="field.key"
                            :value="seoData[settingName(page.key, field.key)]"
                            @input="$set(seoData, settingName(page.key, field.key), $event)"
                            :label="field.label"
                            :textarea="field.key === 'description'"></translated-field>
        </template>
      </v-card-text>
    </v-card>

    <div class="form-actions">
      <v-btn class="btn-primary" large depressed @click="updateContent">
        <v-icon left>mdi-content-save</v-icon>
        ذخیره تغییرات
      </v-btn>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader.vue";
import TranslatedField from "@/components/General/TranslatedField.vue";

export default {
    name: "SeoSetting",

    components: {PageHeader, TranslatedField},

    data() {
        return {
            seoData: {},
            // Setting names are seo_<page>_meta_<field>.
            pages: [
                {key: 'home_page', title: 'صفحه اصلی', icon: 'mdi-home'},
                {key: 'categories', title: 'دسته‌بندی‌ها', icon: 'mdi-shape'},
                {key: 'search', title: 'جستجو', icon: 'mdi-magnify'},
                {key: 'blog', title: 'بلاگ', icon: 'mdi-note-text'},
                {key: 'contact_us', title: 'تماس با ما', icon: 'mdi-email'},
                {key: 'about_us', title: 'درباره ما', icon: 'mdi-information'},
            ],
            seoFields: [
                {key: 'title', label: 'عنوان'},
                {key: 'description', label: 'توضیحات'},
                {key: 'keywords', label: 'کلمات کلیدی'},
            ],
        }
    },

    mounted() {
        this.getSeoData()
    },

    methods: {
        settingName(page, field) {
            return 'seo_' + page + '_meta_' + field
        },

        getSeoData() {
            this.$store.dispatch("getSeoData").then((res) => {
                this.seoData = res.data
            })
        },

        updateContent() {
            this.$store.dispatch("updateSeoData", this.seoData).then(() => {
                this.getSeoData()
            })
        },
    }
}
</script>

<style scoped>

</style>